import React from "react";
import classNames from "classnames"
import styled, { keyframes } from "styled-components";

const config = require("../../utils/siteConfig");

const Footer = styled.div`
  padding: 2rem 5vh;
  display: flex;
  justify-content: space-between;
  background: #fff;

  &.no-padding {
    padding: 0;
  }

  > * {
    flex: 1;
  }

  @media screen and (max-width: 580px) {
    flex-wrap: wrap;
    > * {
      flex: 1 0 100%;
      max-width: 100%;
    }
  }

  &.aside {
    display: none;
  }

  p {
    margin-bottom: 0;
    color: ${props => props.theme.post.colors.copyright};
    font-size: 0.8em;
    a {
      color: ${props => props.theme.post.colors.copyright};
      padding: 0;
      margin: 0;
      display: inline-block;
      font-weight: 700;
      text-decoration: none;
      border: 0;
      outline: 0;
      text-shadow: none;
    }
  }

  .left, .right {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .left {

  }

  .right {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
  }

  .footer-links {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    a {
      font-size: 0.8em;
      margin-top: .5em;
      text-shadow: none;
      padding: 0;
      margin-right: 1.5rem;
    }
    a:last-of-type {
      margin-right: 0;
    }
  }
`;

const Copyright = styled.p`
  padding: 4em 0 0;
  text-align: right;
`;

const FooterWrapper = (props) => {
  const footerClass = classNames({
    "aside": props.isAside,
    "no-padding": props.noPadding
  })
  return (
    <Footer className={footerClass}>
      <div className="left">
        <p><a href="http://www.ibgs-lübeck.de">Integrative Betreute Grundschule<br />Grönauer Baum e.V.</a><br />
        Reetweg 5-7<br/>
        23562 Lübeck</p>

        <p>TEL 0451 - 12280581<br />
        FAX 0451 - 12280590<br />
        E-MAIL mail@ibgs-luebeck.de</p>
      </div>
      <div className="right">
        <Copyright>{config.copyright}</Copyright>
        <div className="footer-links">
          <a href="http://www.ibgs-lübeck.de/jobs.php">Jobs</a>
          <a href="http://www.ibgs-lübeck.de/impressum.php">Impressum</a>
          <a href="http://www.ibgs-lübeck.de/datenschutz.php">Datenschutz</a>
        </div>
      </div>
    </Footer>
  );
};

export default FooterWrapper;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx